const ZoominfoPersonCompany = function(props) {
  return (
    <td className='cs_company' width="430px">
      {props.CompanyName}
    </td>
  );
}

export default ZoominfoPersonCompany;
